/* eslint-disable camelcase */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions, Errors, Form} from 'react-redux-form';
import {Col, FormGroup, Grid, Row} from 'react-bootstrap';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import ImageUpload from '../../../common/form/elements/image-upload';
import RequiredInput from '../../../common/form/elements/required-input';
import ArrowButton from '../../../common/button-arrow';
import {getTile, updateTiles} from '../../../../actions/home';
import {API_REP_HOME_PAGE, UI_REP_HOME_PAGE, UI_RETAILER_HOME_PAGE} from '../../../../data/homePageTypes';
import ColorPicker from '../../../common/form/elements/color-picker';

class DynamicEditTile extends Component {
  onSubmit = (payLoad) => {
    const {dispatch, match, tile} = this.props;
    const homePageType = this.getHomePageType();
    dispatch(actions.submitFields('deep.tile', updateTiles(
      payLoad,
      match.params.id,
      tile.data.attributes.kind,
      `/admin/homepages/${homePageType}`
    )));
  };
  getHomePageType = () => {
    const {tile} = this.props;
    return (tile && tile.data.attributes['home-page-type'] === API_REP_HOME_PAGE) ? UI_REP_HOME_PAGE : UI_RETAILER_HOME_PAGE;
  };

  componentWillMount() {
    const {dispatch, match} = this.props;
    dispatch(getTile(match.params.id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.tile'));
  }

  render() {
    const {
      formValid, tile, buttonColor, buttonTextColor, tileLoading
    } = this.props;
    const image = tile && tile.data.attributes.links.image;
    const default_img = tile && tile.data.attributes.links['default-image'];
    const homePageType = this.getHomePageType();
    if (tileLoading) {
      return (
        <div className="container-fluid">
          <PageTitle>
            Dynamic edit tile
          </PageTitle>
          <Row>
            <Col lg={12}>
              Loading...
            </Col>
          </Row>
        </div>
      );
    }
    return (
      <Grid bsClass="container" fluid className="homepage">
        <Row>
          <Col lg={12}>
            <BackLink href={`/admin/homepages/${homePageType}`}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Dynamic edit tile
            </PageTitle>
          </Col>
        </Row>
        <Col md={12}>
          {
            tile && (
              <Row>
                <Form model="deep.tile" onSubmit={this.onSubmit}>

                  <Errors className="errors" model="deep.tile"/>

                  <Row>
                    <Col lg={12}>
                      <ImageUpload
                        required
                        label="Default Image"
                        source={default_img}
                        sizeLimit={1024 * 1024}
                        model='.default_image'
                        type={['image/png', 'image/jpg', 'image/jpeg']}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <RequiredInput
                        controlId="label"
                        disabled
                        label="Button label"
                        model="deep.tile.label"
                        placeholder="Button label"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <RequiredInput
                        controlId="link"
                        disabled
                        label="Button link"
                        model="deep.tile.link"
                        placeholder="Button link"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <ImageUpload
                        required
                        source={image}
                        sizeLimit={1024 * 1024}
                        model='.image'
                        type={['image/png', 'image/jpg', 'image/jpeg']}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <FormGroup controlId="buttonColor">
                        <ColorPicker
                          model="deep.tile.button_color"
                          textModel="deep.tile.button_text_color_when_hover"
                          name="deep.tile.button_color"
                          textName="deep.tile.button_text_color_when_hover"
                          label="Button colour*"
                          defaultColor={buttonColor}
                          defaultTextColor={buttonTextColor}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Col md={12}>
                    <Row>
                      <ArrowButton
                        className="float-right"
                        color="red"
                        disabled={!formValid}
                      >
                        save
                      </ArrowButton>
                    </Row>
                  </Col>
                </Form>
              </Row>
            )}
        </Col>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  tile: state.home.home_tile,
  formValid: state.deep.forms.tile.$form.valid,
  tileLoading: state.home.fetching && !state.home.fetched,
  buttonColor: state.deep.forms.tile.button_color.value,
  buttonTextColor: state.deep.forms.tile.button_text_color_when_hover.value
});

export default connect(mapStateToProps)(DynamicEditTile);



// WEBPACK FOOTER //
// ./src/components/admin/homepage-tiles/dynamic-edit-tile/index.jsx